import * as Yup from 'yup'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import Select, {components} from 'react-select'
import {useDispatch, useSelector} from 'react-redux'
import {useFormik} from 'formik'
import { useIntl } from 'react-intl'

import {addNewMessage} from 'src/app/modules/messages/message-list/core/_requests'
import {getUsers, getParty} from './core/_requests'
import {setMessage} from 'src/store/alertMessage/actions'
import {startReload} from 'src/store/ReloadNotification/actions'
import {useQueryRequest} from './core/QueryRequestProvider'
import {useQueryResponse} from './core/QueryResponseProvider'
import {Card} from 'react-bootstrap'

const AddMessageComponent = ({senderId,receiverId, setReceiverId, alterNative, setAlterNative}: any) => {
  const [charCount, setCharCount] = useState(70)
  const [partyLedgerList, setPartyLedgerList] = useState([])
  const [isReceiverMenuOpen, setIsReceiverMenuOpen] = useState(false);
  const [normalEntryParty, setNormalEntryParty] = useState(null);
  const dispatch = useDispatch()
  const {state} = useQueryRequest() as any
  const [loading, setLoading] = useState<any>(false)
  const {refetch} = useQueryResponse()
  const amountInputRef = useRef<any>(null)
  const remarksInputRef = useRef<any>(null)
  const receiverMenuListRef = useRef<HTMLDivElement>(null);
  const shouldResetForm = useSelector((state:any) => state.formReset?.shouldReset);
  const intl = useIntl()
  const inputRef = useRef<any>(null)
  const formRef = useRef<HTMLFormElement>(null)

  const formik = useFormik({
    initialValues: {
      sender_id: state.uuid ? Number(state.uuid) : 0,
      receiver_id: 0,
      amount: 0,
      remarks: '',
    },
    validationSchema: Yup.object({
      receiver_id: Yup.number()
        .min(1, `${intl.formatMessage({ id: 'SELECT.PARTY.NAME' })}`)
        .required(`${intl.formatMessage({ id: 'SELECT.PARTY.NAME' })}`),
      amount: Yup.number()
        .required(`${intl.formatMessage({ id: 'AMOUNT.IS.REQUIRED' })}`)
        .test('not-zero', `${intl.formatMessage({ id: 'AMOUNT.CANNOT.BE.ZERO' })}`, (value) => value !== 0)
        .typeError(`${intl.formatMessage({ id: 'AMOUNT.MUST.BE.A.NUMBER' })}`),
      remarks: Yup.string(),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        setLoading(true);
  
        const modifiedValues = {
          sender_id: Number(values.sender_id),
          receiver_id: Number(values.receiver_id),
          amount: Number(values.amount),
          remarks: values.remarks,
          date: new Date().toISOString().split('T')[0],
        };
  
        await addNewMessage(modifiedValues)
          .then((data: any) => {
            if (data?.status == 200 || data?.responseStatus == 200) {
              dispatch(setMessage('success', data?.data?.message ?? data?.responseMessage));
              refetch();
  
              formik.setFieldValue('amount', 0);
              formik.setFieldValue('remarks', '');
              formik.setFieldValue('sender_id', Number(state.uuid));
              formik.setFieldValue('receiver_id', 0);
              formik.setTouched({}); // Clear validation after successful submission
  
              inputRef?.current?.focus();
              inputRef?.current?.openMenu();

              dispatch(startReload('Add Message', 'reload'));
              dispatch({ type: 'SET_RECEIVER_ID', payload: null }) // <== Critical
              setReceiverId(null) // local state update
              setCharCount(70);
              setLoading(false);
            } else {
              if (data?.status === 400 && data?.Error?.message === "Please enter correct old password") {
                dispatch(setMessage('error', "Please enter correct old password"));
              } else {
                dispatch(setMessage('error', data?.data?.message ?? data?.responseMessage));
              }
            }
          })
          .catch((error: any) => {
            console.log("this error", error);
            if (error?.response?.status === 400) {
              const errorData = error.response.data;
              if (errorData?.Error?.statusCode === 400) {
                dispatch(setMessage("error", errorData?.Error?.message));
              } else {
                const errorMsg = 
                  errorData?.responseData?.msg ||
                  errorData?.responseMessage ||
                  error?.message;
                dispatch(setMessage("error", errorMsg));
              }
            } else {
              dispatch(setMessage("error", error?.message || "An unexpected error occurred"));
            }
            setLoading(false);
            setSubmitting(false);
          });
      } catch (error) {
        console.error("Unexpected Error:", error);
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    console.log('QueryRequestProvider state:', state);
  }, [state]);
  console.log("recccif",receiverId);
  
  useEffect(() => {
    if(receiverId == null){

      formik.setFieldValue('receiver_id', 0)
      setReceiverId(null)
    }
  }, [receiverId]);
 
  const fetchPartyLedgerList = async () => {
    try {
      let data = (await getParty()) as any;
      // console.log("this is the data want", data);
      
      if (data.status === 200 || data.data.length > 0) {
        const mappedPartyLedger = data.data.map((x: any) => ({
          label: x.nameCode,
          value: Number(x.partyId), // Convert partyId to number
          ...x,
        }));
  
        const senderIds = Array.isArray(state?.uuid) 
          ? state.uuid.map(Number) // Convert to numbers
          : [Number(state?.uuid)].filter(Boolean);

        const filteredPartyLedger = mappedPartyLedger.filter(
          (partyLedger: any) => !senderIds.includes(partyLedger.value)
        );
  
        setPartyLedgerList(filteredPartyLedger);
      }
    } catch (err: any) {
      console.error("Something went wrong:", err?.message || "Unknown error");
      setPartyLedgerList([]);
    }
  };

  useEffect(() => {
    fetchPartyLedgerList()
    formik.setFieldValue('sender_id', Number(state.uuid)) // Convert to number
  }, [state])

  useEffect(() => {
    if (inputRef.current && alterNative === 2) {
      inputRef.current.focus();
      inputRef.current.onMenuOpen();
    }
  }, [alterNative, state])
  // useEffect(() => {
  //   if(senderId !== null){

  //     inputRef.current.focus()
  //     inputRef.current.openMenu()
  //   }
  // }, [senderId]);

  // Handle click outside to close dropdown and clear validation
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Get the select component's container element
      const selectContainer = inputRef.current?.select?.containerRef?.current;
      if (selectContainer && !selectContainer.contains(event.target as Node)) {
        setIsReceiverMenuOpen(false);
      }

      // Clear validation when clicking outside the form
      if (formRef.current && !formRef.current.contains(event.target as Node)) {
        formik.setTouched({});
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [formik]);

  useEffect(() => {
    if (shouldResetForm) {
      formik.setFieldValue('amount', '');
      formik.setFieldValue('remarks', '');
      setCharCount(70);
      dispatch({ type: 'RESET_FORM_FIELDS', payload: false }); // Reset the flag
    }
  }, [shouldResetForm, formik, dispatch]);
  const filteredReceiverPartyLedgerList = useMemo(() => {
    return partyLedgerList.filter((x: any) => x.value !== senderId)
  }, [senderId, partyLedgerList])

  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: '#E4E6EF',
      borderWidth: '2px',
      borderRadius: '0.475rem',
      cursor: 'pointer',
      minHeight: '54.25px',
      boxShadow: 'none',
      fontSize: '16px',
      '&:hover': {
        borderColor: '#cdcdde',
      },
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      lineHeight: '1.5',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
    }),
    option: (provided: any) => ({
      ...provided,
      cursor: 'pointer', // Optional: adds pointer to dropdown options too
    }),
  }
  


  return (
    <Card.Body className='p-4'>
      <Card.Title className='border-bottom py-3 mb-3'>Normal Entry</Card.Title>
      <form ref={formRef} onSubmit={formik.handleSubmit}>
        <div className='form-group mb-3'>
          <Select
            options={filteredReceiverPartyLedgerList}
            className=''
            placeholder='Select Party'
            ref={inputRef}
            styles={customSelectStyles}
            onChange={(selectedOption: any) => {
              const receiverId = selectedOption ? Number(selectedOption.value) : 0
              formik.setFieldValue('receiver_id', receiverId)
              amountInputRef.current?.focus()
              setReceiverId(receiverId)
              setIsReceiverMenuOpen(false)
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 9 && e.shiftKey) {
                e.preventDefault()
                setAlterNative(1)
              }
              if (e.key === 'Tab') {
                e.preventDefault();
                amountInputRef.current?.focus();
              }
            }}
           
            value={
              formik.values.receiver_id
                ? filteredReceiverPartyLedgerList.find(
                    (option: any) => option.value === formik.values.receiver_id
                  )
                : null
            }
            filterOption={(option, inputValue) => {
              if (!inputValue) return true;
              return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
            }}
            // menuIsOpen={isReceiverMenuOpen}
            // onMenuClose={() => setIsReceiverMenuOpen(false)}
            // onFocus={() => setIsReceiverMenuOpen(true)}
          />
          {formik.touched.receiver_id && formik.errors.receiver_id ? (
            <div className='text-danger'>{formik.errors.receiver_id}</div>
          ) : null}
        </div>

        <div className='form-group mb-3'>
          <input
            placeholder='Amount'
            type='text'
            name='amount'
            className='form-control mb-2'
            onChange={(e: any) => {
              let value = e.target.value;
                if (value.length > 12) {
                  value = value.slice(0, 12);
                }

                const regex = /^-?\d*$/;
                if (regex.test(value)) {
                  formik.setFieldValue('amount', value);
                }
            }}
            value={formik.values.amount === 0 ? '' : formik.values.amount}
            ref={amountInputRef}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                remarksInputRef.current?.focus()
              }
            }}
            onPaste={(e) => {
              e.preventDefault()
              let pastedText = e.clipboardData.getData('Text').replace(/[^0-9-]/g, '')
              const numericValue = pastedText === '' ? 0 : Number(pastedText)
              
              if (String(Math.abs(numericValue)).length <= 12) {
                formik.setFieldValue('amount', numericValue)
              }
            }}
          />
          {formik.touched.amount && formik.errors.amount ? (
            <div className='text-danger'>{formik.errors.amount}</div>
          ) : null}
        </div>

        <div className='form-group mb-3'>
          <textarea
            placeholder='Remarks'
            name='remarks'
            maxLength={70}
            rows={3}
            style={{maxHeight: '190px'}}
            className='form-control mb-3'
            onChange={(e: any) => {
              const inputValue = e.target.value
              formik.setFieldValue('remarks', inputValue)
              setCharCount(70 - inputValue.length)
            }}
            value={formik?.values?.remarks}
            ref={remarksInputRef}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey && !loading) {
                e.preventDefault()
                formik.handleSubmit()
              }
            }}
          />
          {formik.touched.remarks && formik.errors.remarks ? (
            <div className='text-danger'>{formik.errors.remarks}</div>
          ) : null}
          <div className='text-end'>
            <small className={charCount <= 10 ? 'text-danger' : ''}>
              Remaining characters: {charCount}
            </small>
          </div>
        </div>
        <div className='text-left'>
          <button 
            type='submit' 
            className='btn btn-sm btn-primary mb-3 me-3' 
            disabled={loading}
            onClick={() => {
              // Set all fields as touched when submit is clicked
              formik.setTouched({
                receiver_id: true,
                amount: true,
                remarks: true
              });
            }}
          >
            {loading ? 'Please Wait...' : 'Submit'}
          </button>
        </div>
      </form>
    </Card.Body>
  )
}

export default AddMessageComponent